export function createCsvLink(fileName: string, fileContent: string): void {
    const link = document.createElement('a');
    link.href = 'data:text/csv;base64,' + fileContent;
    link.download = fileName + '.csv';
    link.click();
}
